import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export type TotalizerCardIconColor = 'blue' | 'blueDark' | 'green' | 'orange' | 'red' | 'grey';

@Component({
  selector: 'app-totalizer-card',
  templateUrl: './totalizer-card.component.html',
  styleUrls: ['./totalizer-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TotalizerCardComponent {
  @Input() icon = '';
  @Input() iconColor: TotalizerCardIconColor = 'blue';
  @Input() label = '';
  @Input() value: string | number | null = null;
  @Input() tooltip = '';
  @Input() hero = false;
  @Input() hidden = false;
  @Input() detailsIcon = false;
  @Input() detailsTooltip = '';
  @Input() clickable = false;
  @Output() cardClick = new EventEmitter<void>();

  onClick(): void {
    if (this.clickable) this.cardClick.emit();
  }
}
